<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Invalid Transaction IDs Detected</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body pb-0" hsDraggable="modal-dialog">
  <div>
    Your search contains {{ this.transactionIds.length }} invalid Transaction
    IDs.
  </div>
  <button class="copyButton" (click)="copyTransactionIdsTableFormat()">
    Copy invalid IDs in Table Format
  </button>
  <button class="copyButton" (click)="copyTransactionIdsCommaSeparated()">
    Copy invalid IDs as a Comma Separated List
  </button>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button
    nf-button="save"
    (click)="activeModal.close()"
    aria-label="Acknowledge Button"
  >
    Acknowledge
  </button>
  <button
    nf-button
    ngbAutoFocus
    (click)="activeModal.dismiss()"
    aria-label="Cancel Button"
  >
    Cancel
  </button>
</div>
